import React from "react";
import { useTranslation } from "react-i18next";

// Tokens do protótipo (cor do negócio via prop, fallback para W padrão)
const SAGE = "#4A6157";
const W_DEFAULT = "#672E37";

// Ícone caixa 3D (aberto / a pagar)
const IcCaixa = ({ size = 17, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
            d="M3.5 7.5L12 3.5l8.5 4v9L12 20.5l-8.5-4v-9z"
            stroke={color}
            strokeWidth="1.8"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 7.5L12 11.6l8.5-4.1M12 11.6v8.9"
            stroke={color}
            strokeWidth="1.8"
            strokeLinejoin="round"
        />
    </svg>
);

// Ícone check circle (pago)
const IcCheck = ({ size = 16, color = SAGE }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.9" />
        <path
            d="M8.3 12.3l2.5 2.5 4.9-5.3"
            stroke={color}
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/**
 * LinhaPacote — card/linha de estado de pacote (REQ-07 / RN-07).
 *
 * Props:
 *  nome      {string}   nome do pacote
 *  total     {number}   quantidade total de sessões
 *  feitas    {number}   sessões já realizadas
 *  valeAte   {string}   "DD/MM/AAAA" — data de validade
 *  aberto    {boolean}  true = "A pagar com o pacote" (cor W); false = "Pago" (sage)
 *  novo      {boolean}  true = "1ª de N" em vez de "X de Y disponíveis"
 *  card      {boolean}  true = fundo branco com borda; false = inline sem fundo
 *  acao      {string}   texto do botão de ação (ex: "Trocar"), ou null
 *  onAcao    {function} callback do botão de ação
 *  businessColor {string} cor W do negócio (fallback para W_DEFAULT)
 */
const LinhaPacote = ({
    nome,
    total,
    feitas = 0,
    valeAte,
    aberto = false,
    novo = false,
    card = true,
    acao = null,
    onAcao = null,
    businessColor,
}) => {
    const { t } = useTranslation();
    const W = businessColor || W_DEFAULT;
    const cor = aberto ? W : SAGE;
    const apoio = aberto ? "#7A4A55" : "#5B6E65";

    const restantes = total - feitas;
    const saldo = novo
        ? t("package_line_first_of", { total })
        : restantes <= 0
            ? t("confirmation_session_all_used", { total })
            : t("package_line_remaining", { remaining: restantes, total });

    const containerStyle = card
        ? {
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              background: "#fff",
              border: "1px solid #DDD8CE",
              borderRadius: 12,
              padding: "12px 13px",
          }
        : {
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              marginTop: 9,
          };

    return (
        <div style={containerStyle}>
            {/* Ícone */}
            <div style={{ flexShrink: 0, marginTop: 1 }}>
                {card
                    ? aberto
                        ? <IcCaixa size={17} color={W} />
                        : <IcCaixa size={17} color={SAGE} />
                    : aberto
                        ? <IcCaixa size={16} color={W} />
                        : <IcCheck size={16} color={SAGE} />}
            </div>

            {/* Conteúdo */}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        fontSize: card ? 13.5 : 13,
                        fontWeight: 700,
                        color: cor,
                        lineHeight: 1.3,
                    }}>
                    {aberto ? t("package_line_to_pay") : t("package_line_paid")}
                </div>
                {nome && (
                    <div
                        style={{
                            fontSize: 12.5,
                            color: apoio,
                            marginTop: 2,
                            lineHeight: 1.35,
                        }}>
                        {nome}
                    </div>
                )}
                <div style={{ fontSize: 12.5, color: apoio, marginTop: 2 }}>
                    {saldo}
                    {valeAte ? ` · ${t("package_line_valid_until", { date: valeAte })}` : ""}
                </div>
            </div>

            {/* Botão de ação */}
            {acao && (
                <button
                    onClick={onAcao}
                    style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        fontFamily: "inherit",
                        fontSize: 12.5,
                        fontWeight: 700,
                        color: cor,
                        flexShrink: 0,
                        marginTop: card ? 1 : 0,
                    }}>
                    {acao}
                </button>
            )}
        </div>
    );
};

export default LinhaPacote;
